<div class="container">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <img height="90" width="90" src="assets/gif/loader.gif" alt="Loading..." />
      <div *ngIf="loadingText">{{loadingText}}</div>
  </div>
</div>
